var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin_icon",
    fill: "#837d8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C16.2989899,0 21,4.70101013 21,10.5 C21,16.2989899 16.2989899,21 10.5,21 C4.70101013,21 0,16.2989899 0,10.5 C0,4.70101013 4.70101013,0 10.5,0 Z M7,7 L4,7 L4,16 L7,16 L7,7 Z M11.9948092,7.00024629 L9,7.00024629 L9,16 L11.9948092,16 L11.9948092,11.4150346 C11.9948092,8.86810427 15.0016066,8.65947361 15.0016066,11.4150346 L15.0016066,11.4150346 L15.0016066,16 L18,16 L18,10.4700604 C18,6.17226895 13.2512092,6.3285374 11.9948092,8.44429768 L11.9948092,8.44429768 L11.9948092,7.00024629 Z M5.5,3 C4.672,3 4,3.67176871 4,4.5 C4,5.32823129 4.672,6 5.5,6 C6.32885714,6 7,5.32823129 7,4.5 C7,3.67176871 6.328,3 5.5,3 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedinIcon);
export default __webpack_public_path__ + "static/media/footer_linkedin_icon.2ec8e60c.svg";
export { ForwardRef as ReactComponent };